export default __webpack_public_path__ + "4f0f432a0f643d1e0752c91931d6af10.svg";